import React from 'react';
import { InternationalizationContext } from '../../../../src/Utils/Contexts';
import ModalPane from '../ModalPane/ModalPane';

interface Props {
  toLang: string;
  onClose: Function;
  onConfirm: Function;
}

export default function LangConfirmation(props: Props) {
  return (
    <div className="sf-lang-confirmation-w">
      <InternationalizationContext.Consumer>
        {val => {
          return (
            <ModalPane
              buttons={[
                {
                  label: val.data.confirmLabel[props.toLang],
                  onClick: () => {
                    props.onConfirm();
                  }
                }
              ]}
              onClose={() => {
                props.onClose();
              }}
            >
              <div
                className="langConfirm body-text-1"
                dangerouslySetInnerHTML={{
                  __html: val.data.langConfirmationLabel[props.toLang]
                }}
              />
            </ModalPane>
          );
        }}
      </InternationalizationContext.Consumer>
    </div>
  );
}
